import { MENU_ITEMS, MenuItemType, CUSTOMER_MENU_ITEMS } from 'appConstants';
import { getDeviceListFromSession, getUserIdFromSession, getUserInfoFromSession } from 'utils/storageFunctions';
import { APICore } from './api/apiCore';
import { sl } from 'date-fns/locale';

// const loginData = JSON.parse(sessionStorage.getItem('USER_DATA') || ' ');
const getMenuItems = () => {
    const { customerId, type } = getUserInfoFromSession();
    const skyCustomerId = customerId === '6a02e9c03deb4fabbf1b44cd' || type === 'Admin';

    // create a result array; when not the sky customer, remove item at index 1
    let items = CUSTOMER_MENU_ITEMS;
    if (!skyCustomerId) {
        items = CUSTOMER_MENU_ITEMS.filter((_, i) => i !== 1);
    }
    console.log(customerId, skyCustomerId, type);

    return items;
};

const findAllParent = (menuItems: MenuItemType[], menuItem: MenuItemType): string[] => {
    let parents: string[] = [];
    const parent = findMenuItem(menuItems, menuItem['parentKey']);

    if (parent) {
        parents.push(parent['key']);
        if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
    }

    return parents;
};

const findMenuItem = (
    menuItems: MenuItemType[] | undefined,
    menuItemKey: MenuItemType['key'] | undefined
): MenuItemType | null => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

export { getMenuItems, findAllParent, findMenuItem };
